import React from 'react';
import { Box, Stack, Typography, IconButton, Collapse } from '@mui/material';
import dayjs from 'dayjs';
import { ExpandMore } from '@mui/icons-material';

import { currencyUtils } from 'skipify-types';
import { MIT } from '../../../../store/modules/mit/types';
import { MITStatusChip } from '../StatusChip/MITStatusChip';
import { MITDetails } from '../MITDetails';
import { formatCurrency } from '../../../../util/formatters';

type Props = {
  mit: MIT;
  isExpanded: boolean;
  setIsExpanded: (mitId: string | null) => void;
};

export const RecentTransaction = ({ mit, isExpanded, setIsExpanded }: Props) => {
  return (
    <Box sx={{ position: 'relative' }}>
      <Stack
        sx={{
          backgroundColor: 'white',
          borderRadius: '8px',
          border: '1px solid',
          borderColor: 'grey.300',
          height: isExpanded ? '684px' : '115px',
          transition: 'height 0.5s',
        }}
      >
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'flex-start',
            pt: 3,
            px: 3,
          }}
        >
          <Stack direction="row" spacing={3} alignItems="center">
            <MITStatusChip status={mit.status} />
            <Typography sx={{ fontSize: 12, color: 'grey.600' }}>
              {dayjs(mit.createdAt).format('M/D/YY h:mma')}
            </Typography>
          </Stack>
          <IconButton
            aria-label="View MIT"
            onClick={() => setIsExpanded(isExpanded ? null : mit.mitId)}
            sx={{
              color: 'grey.800',
              marginTop: -1.5,
              marginRight: -2,
              transform: isExpanded ? 'rotate(-180deg)' : 'rotate(0deg)',
              transition: 'transform 0.2s',
            }}
          >
            <ExpandMore />
          </IconButton>
        </Box>
        <Collapse in={isExpanded}>
          <Box sx={{ height: '632px', overflowY: 'auto', overflowX: 'hidden' }}>
            <MITDetails mit={mit} merchantId={mit.merchantId} />
          </Box>
        </Collapse>
        <Collapse in={!isExpanded}>
          <Box
            sx={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
              '& p': {
                color: 'grey.900',
                fontSize: '14px',
              },
              pt: 2,
              px: 3,
              pb: 3,
            }}
          >
            <Typography>
              {mit.customer.firstName} {mit.customer.lastName}
            </Typography>
            <Typography>{formatCurrency(currencyUtils.minorToMajor(mit.amount))}</Typography>
          </Box>
        </Collapse>
      </Stack>
    </Box>
  );
};
